export enum ROLES {
  ROLE_VIEW_ADVISER = 'ROLE_VIEW_ADVISER',
  ROLE_EDIT_ADVISER = 'ROLE_EDIT_ADVISER',
  ROLE_VIEW_FIRM = 'ROLE_VIEW_FIRM',
  ROLE_EDIT_FIRM = 'ROLE_EDIT_FIRM',
  ROLE_BULK_INVITER = 'ROLE_BULK_INVITER',
  ROLE_INSIGHTS_VIEWER = 'ROLE_INSIGHTS_VIEWER',
  ROLE_ELEVATION = 'ROLE_ELEVATION',
  ROLE_EXPORTER = 'ROLE_EXPORTER',
  ROLE_EDIT_RISKS_AND_OPPORTUNITIES = 'ROLE_EDIT_RISKS_AND_OPPORTUNITIES',
  ROLE_EDIT_ENQUIRIES ='ROLE_EDIT_ENQUIRIES',
  IS_AUTHENTICATED_2FA_IN_PROGRESS='IS_AUTHENTICATED_2FA_IN_PROGRESS'
}

export enum PERMISSIONS {
  CAN_EDIT_RISKS_AND_OPPORTUNITIES = 'CAN_EDIT_RISKS_AND_OPPORTUNITIES',
  IS_NETWORK_VIEW_ON_NETWORK = 'IS_NETWORK_VIEW_ON_NETWORK',
  HAS_TOP_RATED_FEATURE = 'HAS_TOP_RATED_FEATURE',
  IS_NETWORK_VIEW = 'IS_NETWORK_VIEW',
  IS_FIRM_VIEW = 'IS_FIRM_VIEW',
  IS_FIRM_VIEW_ON_FIRM_OR_NETWORK = 'IS_FIRM_VIEW_ON_FIRM_OR_NETWORK',
  CAN_VIEW_INVITE_REQUESTS = 'CAN_VIEW_INVITE_REQUESTS',
  SHOW_VERIFIED_SIDEBAR = 'SHOW_VERIFIED_SIDEBAR',
  SHOW_VERIFIED_STATISTICS = 'SHOW_VERIFIED_STATISTICS',
  IS_FIRM_WIEW_OR_IS_NETWORK_VIEW_ON_NETWORK = 'IS_FIRM_WIEW_OR_IS_NETWORK_VIEW_ON_NETWORK',
  IS_FULL_FIRM_OR_NETWORK_VIEW = 'IS_FULL_FIRM_OR_NETWORK_VIEW',
  CAN_ACCESS_FIRM_MARKETING_TOOLS_PAGE = 'CAN_ACCESS_FIRM_MARKETING_TOOLS_PAGE',
  IS_TOP_RATED = 'IS_TOP_RATED',
  CAN_ACCESS_ARTICLES = 'CAN_ACCESS_ARTICLES',
  CAN_VIEW_SENSITIVE_ANSWERS = 'CAN_VIEW_SENSITIVE_ANSWERS',
  CAN_VIEW_ELEVATION_AI_SUMMARY = 'CAN_VIEW_ELEVATION_AI_SUMMARY',
}

export type Role = keyof typeof ROLES
export type Permission = keyof typeof PERMISSIONS
